// extracted by mini-css-extract-plugin
export default {"aldDrawer":"Drawer_aldDrawer__8Yed7 ald-drawer"};